// @flow
import * as React from 'react';

import { JsonLd } from 'react-schemaorg';
import type { Organization } from '../types';

export const organizationDef: Organization = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Yapita Health PVT LTD',
  url: 'https://yapitahealth.com',
  logo: 'https://yapitahealth.com/images/logo-square.svg'
};

const OrganizationDef = (): React.Node => <JsonLd item={organizationDef} />;

export default OrganizationDef;
